import { createApi, retry } from '@reduxjs/toolkit/query/react';
import { graphqlRequestBaseQuery } from '@rtk-query/graphql-request-base-query';
import { baseQueryWithReauth } from '../interceptors/authErrorInterceptor';
import { resolver } from '../resolver';
import { itemsSearchQueryFn } from './itemsSearchQueryFn';
import { ItemSearchReturnResponse } from './itemsSearchTypes';

export const itemsSearchService = createApi({
  reducerPath: 'itemsSearch',
  baseQuery: retry(
    baseQueryWithReauth(
      graphqlRequestBaseQuery({
        client: resolver.getMasterQueryGraphQLClient(),
      }),
    ),
    {
      maxRetries: 2,
    },
  ),
  endpoints: (builder) => ({
    getItems: builder.query<ItemSearchReturnResponse[], { search: string }>({
      queryFn: itemsSearchQueryFn,
      keepUnusedDataFor: 0,
    }),
  }),
});

export const { useLazyGetItemsQuery } = itemsSearchService;
